export default "__VITE_ASSET__59d3930e__"